import React, { Component } from 'react'

const NewsletterForm = ({ list = 'consolelog', ...rest}) => {
  const subscribe = () => {
    window.open(`https://tinyletter.com/${list}`, 'popupwindow', 'scrollbars=yes,width=800,height=600')
    return true
  }
  return (
    <form
      action={`https://tinyletter.com/${list}`}
      method="post"
      target="popupwindow"
      onSubmit={subscribe}
      {...rest}
      >
      <div className="field has-addons has-addons-centered">
        <div className="control">
          <input className="input" type="email" name="email" required placeholder="enter your email" />
        </div>
        <div className="control">
          <button type="submit" className="button is-primary">
            subscribe
          </button>
        </div>
      </div>
    </form>
  )
}

export default NewsletterForm



// WEBPACK FOOTER //
// ./src/components/NewsletterForm.jsx